/* ==========================================================================
   SearcherFli > Client > Calendar
   ========================================================================== */

/* Modules */
const Calendar = require('@bluekiri/alexandria-contrib-components/components/calendar-rxjs/client/js');

/* eslint-disable */
const CalendarActions = require('@bluekiri/alexandria-contrib-components/components/calendar-rxjs/client/js/store/actions');
/* eslint-enable */

const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const { renderCalendar } = require('../../../renders');

const { actions } = require('../store/actions');

const configuration = require('../config');
const { isRoundtrip, isOneway } = require('../helpers');
const { ONEWAY, ROUNDTRIP } = require('../product/constants');
const {
    CALENDAR: { CALENDAR_DEFAULT_START_DATE, CALENDAR_DEFAULT_END_DATE }
} = require('../../../constants/index');

/* Is Empty */
function isEmptyCalendar(instance) {
    const { value } = instance.calendar.fp.input;

    instance.calendar.actions.setValid();

    if (!value) {
        instance.calendar.actions.setError();
    }

    return !value;
}

/* Add */
function addCalendar(instance) {
    if (instance.calendar) return;

    /* Data */
    const { literals, context, calendar } = instance.config;
    const { product } = instance.store.select('data');
    const dates = instance.store.select('data').calendar;

    /* Template */
    const template = renderCalendar(
        {
            calendar: {
                ...calendar,
                startDate: dates[0] || dates,
                endDate: dates[1]
            },
            product
        },
        literals,
        context
    );

    /* Node */
    const node = toNode(template)[0];

    /* Add node */
    instance.hooks.middle.insertBefore(node, instance.passengers.element);

    /* Init */
    initCalendar(instance);
}

/* Init */
function initCalendar(instance) {
    const panel = instance;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeCalendar: payload => {
            return instance.store.dispatch(actions.changeCalendar(payload));
        }
    };

    /* Reference */
    const formatDates = dates => {
        const { product } = instance.store.select('data');
        const {
            fp: {
                input,
                formatDate,
                config: {
                    locale: { rangeSeparator },
                    dateFormat
                }
            }
        } = instance.calendar;

        if (input) {
            if (isRoundtrip(product)) {
                if (dates.length > 1) {
                    input.value = `${formatDate(dates[0], dateFormat)}${rangeSeparator}${formatDate(
                        dates[1],
                        dateFormat
                    )}`;
                } else {
                    input.value = `${formatDate(dates[0], dateFormat)}`;
                }
            } else if (isOneway(product)) {
                input.value = formatDate(dates[0], dateFormat);
            }
        }
    };

    panel.calendar = Calendar(
        `${instance.selector} [data-component='CalendarRxjs'][data-type='${configuration().type.calendar}']`,
        {
            fp: {
                onChange: dates => {
                    const { active } = panel.calendar.store.select('calendar');
                    if (!active) {
                        instance.calendar.actions.toggleActive();
                    }

                    formatDates(dates);
                }
            }
        }
    );

    panel.calendar.updateInputValue = () => {
        const { calendar } = panel.store.select('data');
        formatDates(calendar);
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeCalendar: instance.calendar.store.subscribe((_, action) => {
            if (action.type !== CalendarActions.types.CHANGE_VALUE) return;

            /* Dispatch */
            instance.actions.changeCalendar(action.payload);
        })
    };

    /* Start */
    let { value } = instance.calendar.store.select('calendar');

    if (!value) {
        return;
    }

    if (!value.length) {
        value = [value];
    }

    /* Sync */
    const { lastDates } = instance.store.select('data');
    instance.actions.setSearcher({
        calendar: value,
        lastDates: {
            [ONEWAY]: [new Date(instance.config.calendar.startDate || CALENDAR_DEFAULT_START_DATE)],
            [ROUNDTRIP]: [
                new Date(instance.config.calendar.startDate || CALENDAR_DEFAULT_START_DATE),
                new Date(instance.config.calendar.endDate || CALENDAR_DEFAULT_END_DATE)
            ],
            ...lastDates
        }
    });

    panel.calendar.updateInputValue();
}

/* Destroy */
function destroyCalendar(instance) {
    const panel = instance;

    /* Reference */
    instance.calendar.actions.destroy();
    delete panel.calendar.updateInputValue;
    delete panel.calendar;

    /* Actions */
    delete panel.actions.changeCalendar;

    /* Reactions */
    instance.reactions.changeCalendar.unsubscribe();
    delete panel.reactions.changeCalendar;
}

/* Exports */
module.exports = {
    addCalendar,
    initCalendar,
    destroyCalendar,
    isEmptyCalendar
};
